export default [

    {
        path: "/manutencao",
        name: "maintenance",
        component: () => import("@/views/account/maintenance.vue"),
        meta: {
            title: "Manutenção",
            authRequired: false,
        },
    },
    {
        path: "/cadastrar",
        name: "register",
        component: () => import("@/views/public/register.vue"),
        meta: {
            title: "Efetuar Cadastro",
            authRequired: false,
        },
    },

    {
        path: "/duvidas",
        name: "faqs",
        component: () => import("@/views/public/faqs.vue"),
        meta: {
            title: "Dúvidas",
            authRequired: false,
        },
    },

    {
        path: "/vagas",
        name: "vacancies",
        component: () => import("@/views/public/vacancies.vue"),
        meta: {
            title: "Vagas",
            authRequired: false,
        },
    },

    {
        path: "/vagas/:id",
        name: "vacancy-details",
        component: () => import("@/views/public/details.vue"),
        meta: {
            title: "Detalhes da Vaga",
            authRequired: false,
        },
    },

    {
        path: "/login/:public?",
        name: "login",
        component: () => import("@/views/account/login"),
        meta: {
            title: "Login",
            authRequired: false,
            // beforeResolve(routeTo, routeFrom, next) {
            //     if (store.getters["auth/loggedIn"]) {
            //         next({name: "dashboard"});
            //     } else {
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/esqueceu-senha",
        name: "forgot-password",
        component: () => import("@/views/account/forgot-password.vue"),
        meta: {
            title: "Recuperar Senha",
            authRequired: false,
        },
    },
    {
        path: "/recuperar-senha/:token",
        name: "change-password",
        component: () => import("@/views/account/change-password.vue"),
        meta: {
            title: "Resetar Senha",
            authRequired: false,
        },
    },
    {
        path: "/logout",
        name: "logout",
        component: () => import("@/views/account/logout"),
        meta: {
            title: "Logout",
            authRequired: false,
        },
    },
    {
        path: "/minhas-vagas",
        name: "dashboard",
        meta: {
            title: "Minhas Vagas",
            authRequired: true,
        },
        component: () => import("@/views/dashboard/index"),
    },

    {
        path: "/meu-perfil",
        name: "my-profile",
        meta: {
            title: "Meu Perfil",
            authRequired: true,
        },
        component: () => import("@/views/profile/index.vue"),
    },


    {
        path: "/processo-seletivo/:selective_candidate/:id",
        name: "selective-process",
        meta: {
            title: "Processo Seletivo",
            authRequired: true,
        },
        component: () => import("@/views/selective-process/index.vue"),
    },

    // {
    //     path: "/jornada-26",
    //     name: "journey",
    //     component: () => import("@/views/journey/index.vue"),
    //     meta: {
    //         title: "Página Principal",
    //         authRequired: false,
    //     },
    // },

    {
        path: "/:city?",
        name: "landing-page",
        component: () => import("@/views/public/index.vue"),
        meta: {
            title: "Página Principal",
            authRequired: false,
        },
    },


];
